import { Text } from '@/components/ui/text'
import { type Component, For } from 'solid-js'
import { useService } from 'solid-services'
import { useChannelsReads } from '../../../state/channelReads/state'
import { useMessageMention } from '../../../state/mentions/useMentions'
import { useSelectors } from '../../../state/selectors'
import { SharedChannelItem, SharedChannelList } from '../SharedChannel'

const formatString = (input: string): string => input.replace(/-/g, ' ').replaceAll('and', '&')

const Channels: Component<{ height?: string; isMinimal?: boolean }> = (props) => {
  const { generalChannels } = useService(useSelectors)()
  const { messageMentionChannelMap } = useService(useMessageMention)()
  const { toggleSubscribed } = useService(useChannelsReads)()

  return (
    <SharedChannelList>
      <For each={generalChannels()}>
        {(channel) => (
          <SharedChannelItem
            href={channel.name === 'trade-leaders' ? '/chat' : `/chat/${channel.name}`}
            end={channel.name === 'trade-leaders'}
            isMinimal={props.isMinimal}
            minimalVariant="plain"
            channelId={channel.id}
            isSubscribed={channel.is_subscribed}
            onToggleSubscribe={toggleSubscribed}
            unreadCount={channel.unread_count}
            hasMention={!!messageMentionChannelMap()[channel.id]?.length}
          >
            <Text textStyle='sm' textAlign="left" truncate textTransform='capitalize'>
              {formatString(channel.name)}
            </Text>
          </SharedChannelItem>
        )}
      </For>
    </SharedChannelList>
  )
}

export default Channels
